import { render } from "./SelectionSetTreeNode.vue?vue&type=template&id=4d47e984&scoped=true&ts=true"
import script from "./SelectionSetTreeNode.vue?vue&type=script&lang=ts"
export * from "./SelectionSetTreeNode.vue?vue&type=script&lang=ts"

import "./SelectionSetTreeNode.vue?vue&type=style&index=0&id=4d47e984&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d47e984"]])

export default __exports__